import { refreshToken } from './LoginApiService';
import Swal from 'sweetalert2';

export const SetupInterceptors = (apiClient) => {
    let isRefreshing = false;
    let refreshSubscribers = [];
  
    apiClient.interceptors.request.use(
      (config) => {
        const authData = JSON.parse(localStorage.getItem("authUser") || "{}");
        if (authData.accessToken) {
          config.headers.Authorization = `Bearer ${authData.accessToken}`;
        }
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  
    apiClient.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config;
  
        // Skip interceptor logic for login endpoint - let login errors be handled by the component
        if (originalRequest.url && originalRequest.url.includes('/api/Auth/login')) {
          return Promise.reject(error);
        }
  
        if (error.response?.status === 401 && !originalRequest._retry) {
          if (isRefreshing) {
            return new Promise((resolve) => {
              refreshSubscribers.push((token) => {
                originalRequest.headers.Authorization = `Bearer ${token}`;
                resolve(apiClient(originalRequest));
              });
            });
          }
  
          originalRequest._retry = true;
          isRefreshing = true;
  
          try {
            const authData = JSON.parse(localStorage.getItem("authUser") || "{}");
            const refreshTokenValue = authData.refreshToken;
            
            if (!refreshTokenValue) {
              // No refresh token available, session expired
              localStorage.removeItem('permissions'); // Clear stale permissions
              Swal.fire({
                title: "Session Expired",
                text: "Please login again",
                icon: "warning",
                confirmButtonText: "Login",
              }).then(() => {
                localStorage.clear();
                window.location.href = "/login";
              });
              return Promise.reject(error);
            }
            
            const tokens = await refreshToken(authData.accessToken, refreshTokenValue);
            
            // Update stored tokens
            authData.accessToken = tokens.accessToken;
            authData.refreshToken = tokens.refreshToken;
            localStorage.setItem("authUser", JSON.stringify(authData));
  
            // Update authorization header
            apiClient.defaults.headers.common["Authorization"] = `Bearer ${tokens.accessToken}`;
            originalRequest.headers.Authorization = `Bearer ${tokens.accessToken}`;
  
            // Execute all pending requests
            refreshSubscribers.forEach((callback) => callback(tokens.accessToken));
            refreshSubscribers = [];
  
            return apiClient(originalRequest);
          } catch (error) {
            // Refresh token failed, session timed out
            localStorage.removeItem('permissions'); // Clear stale permissions
            Swal.fire({
              title: "Session Timed Out",
              text: "Please login again",
              icon: "warning",
              confirmButtonText: "Login",
            }).then(() => {
              localStorage.clear();
              window.location.href = "/login";
            });
            return Promise.reject(error);
          } finally {
            isRefreshing = false;
          }
        }
  
        return Promise.reject(error);
      }
    );
  };
  